import React from "react";
import twitter from "../../../../assets/Images/twitter.png"
import telegram from "../../../../assets/Images/telegram.png"
import medium from "../../../../assets/Images/medium.png"
import { Image } from "../../../Styles/style";
import { DashboardDesktopMainMenu, MenuLink } from "../navBar/styles";

const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass
    {
      title: "Terms",
      link: "",
    },
    {
      title: "Privacy",
      link: "",
    },
    {
      title: "Docs",
      link: "",
    },
    {
      title: "Contact Us",
      link: "",
    },
  ];
const DashboardFooter = (props) => {
    
  return (
    <DashboardDesktopMainMenu maxWidth="xl">
      <div style={{display:"flex" , alignItems:"center"}}>
        {menuList.map((value, i) => <MenuLink fs="12px" key={i} href={value.link} target={value.target} className={value.customClass}>{value.title}</MenuLink> )}
      </div>
      <div style={{display:"flex" , alignItems:"center"}}>
        <MenuLink p="0 5px 0 10px" href="https://twitter.com/shialending"  target="blank">
          <Image src={twitter}/>
        </MenuLink>
        <MenuLink  p="0 5px"  href="https://t.me/shialending" target="blank">
          <Image src={telegram}/>
        </MenuLink>
        <MenuLink p="0 5px">
          <Image src={medium}/>
        </MenuLink>
      </div>
    </DashboardDesktopMainMenu>
  );
};

export default DashboardFooter;

